import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import {MeusLaudosCDModel} from "./meus-laudos-cd.model";
import {Funcoes} from "../../funcoes";
import {Global} from "../../global";
import {ClientesLaudosCDService} from "./clientes-laudos-cd.service";


@Component({
  selector: 'app-meus-laudos-cd-form',
  templateUrl: './meus-laudos-cd-form.component.html'
})
export class MeusLaudosCDFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  laudo: any = { terminal: {}, produto: {} };
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  comPDF: boolean = true;
  url = '';
  alturaTela;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private laudosService: ClientesLaudosCDService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    route.params.subscribe(params => {
      this.url = global.dominio_site+'/cli/clientes-usuarios/meus-laudos-cd/'+params['id_laudo']+'/pdf/?tk='+localStorage.getItem('token');
    });

    this.alturaTela = window.screen.availHeight - 250;

    this.form = formBuilder.group({
      id_laudo_cd: [],
      terminal: [],
      produto: [],
      data_descarga: [],
      numero: [],
      referencia: [],
      pdf: []
    });

  }

  ngOnInit() {
    let id = this.route.params.subscribe(params => {
      let id = params['id_laudo'];

      this.title = this.func.traduzir('front.visualizarLaudoPdf');

      if (!id) {
        return;
      }

      this.laudosService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            this.laudo = json.Payload[0];
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-laudos-cd/meus-laudos-cd-form.component.ts